export enum TABLE_SORT_ORDER {
    ASCENDING='asc',
    DESCENDING='desc'
}